import Vue from 'vue'
import Vuex from 'vuex'
import app from "./app"
import appConfig from "./app-config"
import verticalMenu from "./vertical-menu"
import auth from "@/store/auth";
import SidebarStore from "@/store/sidebar";
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import UserStore from "@/store/user/user.store.js";
import loading from "@/store/loading/index.js";
import AttendanceStore from "@/views/attendance/store/attendance.store.js";
import NotificationStore from "@/store/notifications/notifications.store.js"
import RRHHStore from "@/views/rrhh/store";

Vue.use(Vuex)

const initialState = {
  RRHHStore: { ...RRHHStore.state },
}
export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    ...RRHHStore,
    SidebarStore,
    'app-ecommerce': ecommerceStoreModule,
    UserStore,
    loading,
    AttendanceStore,
    NotificationStore
  },
  mutations: {
    resetState(state) {
      Object.keys(state).forEach(key => {
        Object.assign(state[key].initialState[key]);
      });
    }
  },
  actions: {},
  state: {},
  strict: process.env.DEV,
})
